import { getPublicHttpClient } from '../api/axiosInstance'
import { ConfigProvider } from 'antd'

import { useQuery } from '@tanstack/react-query'

export const key = 'theme'

export const updateTheme = (theme) => {
  ConfigProvider.config({
    theme: {
      ...theme
    }
  })

  // const fontFamilyRule = `:root{--ant-font-family:'${theme.fontFamily}'}`;
  // document.documentElement.style.setProperty('--your-variable', '#CCC');
  // var sheet = document.styleSheets[0];
  // sheet.insertRule(fontFamilyRule);

  document.documentElement.style.setProperty(
    '--ant-font-family',
    theme.fontFamily
  )
  document.documentElement.style.setProperty(
    '--ant-dark-color',
    theme.darkColor
  )
  document.documentElement.style.setProperty(
    '--ant-light-color',
    theme.lightColor
  )
}

export const testTheme = (current, form) => {
  const { darkMenu, darkHeader, ...rest } = form
  const theme = {
    ...current,
    ...rest,
    darkMenu: form.darkMenu ? 'true' : 'false',
    darkHeader: form.darkHeader ? 'true' : 'false'
  }

  updateTheme(theme)
}


/*
export function testTheme (form) {
  return async (dispatch, getState) => {
      const current = getData(getState());

      const newTheme = {
          ...current,
          ...form,
          darkMenu: form.darkMenu ? "true" : "false",
          darkHeader: form.darkHeader ? "true" : "false",
      };

      dispatch(success(newTheme));
      updateTheme(newTheme);
  };
}
*/

export const getTheme = async () => {
  const apiClient = getPublicHttpClient()

  const response = await apiClient.get('/public/theme')
  updateTheme(response.data)

  return response.data
}

const useTheme = () => {
  return useQuery({
    queryKey: [key],
    queryFn: () => getTheme(),
    refetchOnWindowFocus: false,
    refetchInterval: 1000 * 60 * 60, //  1 hora en ms
    staleTime: 120 * (60 * 1000), // 120 minutes
    cacheTime: 120 * (60 * 1000) // 120 minutes
  })
}

export { useTheme }
